import { Injectable } from "@angular/core";
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config, Pagination } from "../shared";
import { PermissionTemplateRequestHdrContainerModel } from '../../../../../models/aggregates/permissions/permission-template-request-hdrs-container.model'
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root',
})
export class PermissionRequestHdrService extends BaseApiTemplateService<PermissionTemplateRequestHdrContainerModel> {
    constructor(http: HttpClient){
        super();
        this.httpClient = http;
    }

    private setUrl(endpoint: string){
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "permission-template-request-hdrs" + endpoint;
        this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "permission-template-request-hdrs" + endpoint;
    }

    sysadminPost(dtoObject: PermissionTemplateRequestHdrContainerModel, apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.post(dtoObject, apiVisa);
    }

    sysadminDelete(guid: string, apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.delete(guid, apiVisa);
    }

    sysadminPut(dtoObject: PermissionTemplateRequestHdrContainerModel, apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.put(dtoObject, apiVisa);
    }

    sysadminGetAll(apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.get(apiVisa);
    }

    sysadminGetByGuid(guid: string, apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.getByGuid(guid, apiVisa)
    }

    sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
        this.setUrl('/sysadmin-ep');
        return super.getByCriteria(pagination, apiVisa);
    }

    sysadminProcess(guid: string, apiVisa: ApiVisa){
        this.setUrl(`/process/sysadmin-ep/${guid}`);

        if(this.endpoint_path && apiVisa.api_domain_url){
            this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.put<ApiResponseModel<PermissionTemplateRequestHdrContainerModel>>(this.apiUrl, null, this.getHttpHeader(apiVisa));
    }
}